
export default {
  submitText: {
    id: 'textResults.submit',
    description: 'Message for a submit button for the social forms',
    defaultMessage: 'Send Text'
  },
  submitEmail: {
    id: 'emailResults.submit',
    description: 'Message for a submit button for the social forms',
    defaultMessage: 'Send Email'
  },
  phone: {
    id: 'textResults.phone',
    description: 'Label message for the phone input field for text results',
    defaultMessage: 'Phone Number'
  },
  phoneError: {
    id: 'textResults.phone.error',
    description: 'Error message for the phone input field for text results',
    defaultMessage: 'A valid 10-digit US phone number is required.'
  },
  phonePlaceholder: {
    id: 'textResults.phone.placeholder',
    description: 'Placeholder message for the phone input field for text results',
    defaultMessage: '(555) 123-4567'
  },
  fromName: {
    id: 'emailResults.fromName',
    description: 'Label message for the from name field for emailed results',
    defaultMessage: "Sender's Name"
  },
  fromNameError: {
    id: 'emailResults.fromName.error',
    description: 'Error message for the from name field for emailed results',
    defaultMessage: "Sender's name is required"
  },
  fromNamePlaceholder: {
    id: 'emailResults.fromName.placeholder',
    description: 'Placeholder message for the from name field for emailed results',
    defaultMessage: "From"
  },
  fromAddress: {
    id: 'emailResults.fromAddress',
    description: 'Label message for the from address field for emailed results',
    defaultMessage: 'Email Address'
  },
  fromAddressError: {
    id: 'emailResults.fromAddress.error',
    description: 'Error message for the from address field for emailed results',
    defaultMessage: "Sender's email address is required"
  },
  fromAddressPlaceholder: {
    id: 'emailResults.fromAddress.placeholder',
    description: 'Placeholder message for the from address field for emailed results',
    defaultMessage: 'user@email.com'
  },
  toName: {
    id: 'emailResults.toName',
    description: 'Label message for the to name field for emailed results',
    defaultMessage: "Recipient's Name"
  },
  toNameError: {
    id: 'emailResults.toName.error',
    description: 'Error message for the to name field for emailed results',
    defaultMessage: "Recipient's name is required"
  },
  toNamePlaceholder: {
    id: 'emailResults.toName.placeholder',
    description: 'Placeholder message for the to name field for emailed results',
    defaultMessage: 'To'
  },
  toAddress: {
    id: 'emailResults.toAddress',
    description: 'Label message for the to address field for emailed results',
    defaultMessage: 'Email Address'
  },
  toAddressError: {
    id: 'emailResults.toAddress.error',
    description: 'Error message for the to address field for emailed results',
    defaultMessage: "Recipient's email address is required"
  },
  toAddressPlaceholder: {
    id: 'emailResults.toAddress.placeholder',
    description: 'Placeholder message for the to address field for emailed results',
    defaultMessage: 'user@email.com'
  },
  copyMe: {
    id: 'emailResults.copyMe',
    description: 'Label text for the copy-me checkbox for emailed results',
    defaultMessage: 'Send a copy to me?'
  },
  carrierCharges: {
    id: 'textResults.carrierCharges',
    description: 'A disclaimer that you may be charged for text message',
    defaultMessage: 'Standard text messaging rates may apply.'
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/social/i18n/MessageDefinitions.js
 **/